var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone, faMicrophoneSlash, faMicrophoneAlt, faStop, faUpload, faCheckCircle, } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useState, useEffect, useRef } from 'react';
import Button from 'components/button/button';
import { ButtonStyle } from 'components/button/prop-types';
const RecorderControls = ({ recorderState, handlers, params, uploadRecording, }) => {
    var _a, _b;
    const { recordingMinutes, recordingSeconds, audio } = recorderState;
    const { startRecording, saveRecording } = handlers;
    const { durationTime, durationUnit, getRawAnswer, question, questionId } = params;
    const [countdown, setCountdown] = useState();
    const [maxTime, setMaxTime] = useState();
    const [timer, setTimer] = useState();
    const audioRef = useRef(null);
    const [isRecordingCountdowm, setIsRecordingCountdowm] = useState(false);
    const [isRecordingStarted, setIsRecordingStarted] = useState(false);
    const [isRecordingPaused, setIsRecordingPaused] = useState(false);
    const [isRecording, setIsRecording] = useState(true);
    const [isFinished, setIsFinished] = useState(false);
    const [isUploaded, setIsUploaded] = useState(false);
    const [userAnswer, setUserAnswer] = useState(false);
    const [uploadLoading, setUploadLoading] = useState(false);
    const [uniqueId, setUniqueId] = useState(Date.now());
    (_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.load();
    const { t } = useTranslation();
    const finishID = () => {
        setUniqueId(Date.now());
    };
    const getDateNumber = (num) => {
        if (num < 0) {
            return '0';
        }
        return num > 9 ? `${num}` : `0${num}`;
    };
    const audioOnLoadMetadata = () => {
        if (audioRef.current.duration === Infinity) {
            audioRef.current.currentTime = Number.MAX_SAFE_INTEGER;
            audioRef.current.ontimeupdate = () => {
                audioRef.current.ontimeupdate = null;
                audioRef.current.currentTime = 0.001;
            };
        }
    };
    useEffect(() => {
        const answer = getRawAnswer && question ? getRawAnswer(question) : undefined;
        if (answer) {
            setUserAnswer(true);
        }
    }, [questionId]);
    useEffect(() => {
        if (durationUnit === 'MINUTES') {
            setMaxTime({ minutes: durationTime, seconds: 0 });
        }
        if (durationUnit === 'SECONDS') {
            setMaxTime({ minutes: Math.floor(durationTime / 60), seconds: durationTime % 60 });
        }
    }, [durationTime, durationUnit]);
    useEffect(() => {
        if (countdown === undefined) {
            return;
        }
        if (countdown === 0) {
            setIsRecordingCountdowm(false);
            startRecording();
            setTimer({
                seconds: 0,
                minutes: 0,
            });
            return;
        }
        const countDownInterval = setInterval(() => {
            setCountdown(countdown - 1);
            clearInterval(countDownInterval);
        }, 1000);
        return () => {
            clearInterval(countDownInterval);
        };
    }, [countdown]);
    useEffect(() => {
        // if (timer === undefined || isRecordingPaused || !isRecording) { return; }
        if (timer === undefined || isRecordingPaused || !isRecording) {
            return;
        }
        {
            /* Stop recording when limit is reached */
        }
        if (recordingMinutes === (maxTime === null || maxTime === void 0 ? void 0 : maxTime.minutes) && recordingSeconds === (maxTime === null || maxTime === void 0 ? void 0 : maxTime.seconds)) {
            // setIsRecordingPaused(true);
            setIsFinished(true);
            saveRecording();
        }
        setTimer({
            seconds: recordingSeconds,
            minutes: recordingMinutes,
        });
    }, [recordingMinutes, recordingSeconds, isRecordingPaused]);
    return (_jsxs(_Fragment, { children: [isRecording && !userAnswer && (_jsxs("div", Object.assign({ className: "container--audio-recording", onClick: () => {
                    if (!isRecordingStarted) {
                        setIsRecordingStarted(true);
                        setIsRecordingCountdowm(true);
                        setCountdown(3);
                    }
                } }, { children: [!isRecordingPaused && _jsx(FontAwesomeIcon, { className: "enabled", icon: faMicrophone }, void 0), isRecordingPaused && _jsx(FontAwesomeIcon, { className: "enabled", icon: faMicrophoneSlash }, void 0), !isRecordingStarted && _jsx("span", Object.assign({ className: "disabled" }, { children: t('QUESTION.AUDIO.START_RECORDING') }), void 0), isRecordingCountdowm && _jsx("span", { children: t('QUESTION.AUDIO.RECORDING_START_IN', { time: countdown }) }, void 0), isRecordingStarted && !isRecordingCountdowm && (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "container--audio-recording__timestamp" }, { children: timer && maxTime && (_jsxs(_Fragment, { children: [_jsxs("span", { children: [`${getDateNumber(recordingMinutes)}:${getDateNumber(recordingSeconds)}`, "\u00A0/"] }, void 0), _jsxs("span", Object.assign({ className: "disabled" }, { children: ["\u00A0", `${getDateNumber(maxTime.minutes)}:${getDateNumber(maxTime.seconds)}`] }), void 0)] }, void 0)) }), void 0), _jsx("div", Object.assign({ className: "button-group" }, { children: _jsx(Button, { className: [ButtonStyle.Secondary, ButtonStyle.Outline, ButtonStyle.Small], icon: faStop, title: t('QUESTION.AUDIO.FINILIZE'), onClick: () => {
                                        setIsRecording(false);
                                        setIsFinished(true);
                                        saveRecording();
                                    } }, void 0) }), void 0)] }, void 0))] }), void 0)), isFinished && audio && (_jsxs("div", Object.assign({ className: "container--audio-recording" }, { children: [_jsx("h6", { children: t('QUESTION.AUDIO.PREVIEW') }, void 0), _jsx("p", { children: t('QUESTION.AUDIO.PREVIEW_DESCRIPTION') }, void 0), _jsx("div", Object.assign({ className: "audio-player-list" }, { children: _jsx("div", Object.assign({ className: "audio-player-list-item" }, { children: _jsx("div", Object.assign({ className: "sumadi-audio-player" }, { children: _jsx("div", Object.assign({ role: "group", tabIndex: 0, "aria-label": "Audio Player", className: "rhap_container" }, { children: _jsx("audio", Object.assign({ ref: audioRef, id: 'audio-recorded-' + uniqueId.toString(), style: { width: '100%' }, controls: true, controlsList: "nodownload", preload: "auto", onLoadedMetadata: audioOnLoadMetadata }, { children: _jsx("source", { src: audio, type: (_b = recorderState.oggFile) === null || _b === void 0 ? void 0 : _b.type }, void 0) }), void 0) }), void 0) }), void 0) }), void 0) }), void 0), _jsxs("div", Object.assign({ className: "button-group" }, { children: [_jsx(Button, { className: [ButtonStyle.Secondary, ButtonStyle.Outline], icon: faMicrophoneAlt, title: t('QUESTION.AUDIO.RECORD_AGAIN'), onClick: () => {
                                    setIsFinished(false);
                                    setIsRecording(true);
                                    setIsRecordingStarted(false);
                                    setIsRecordingPaused(false);
                                    finishID();
                                } }, void 0), _jsx(Button, { className: [ButtonStyle.Secondary, ButtonStyle.Outline], icon: faUpload, title: t('QUESTION.AUDIO.UPLOAD_RECORDING'), loading: uploadLoading, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                    setUploadLoading(true);
                                    yield uploadRecording();
                                    setIsRecording(false);
                                    setIsFinished(false);
                                    setIsUploaded(true);
                                    setUserAnswer(true);
                                }) }, void 0)] }), void 0)] }), void 0)), (isUploaded || userAnswer) && (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "info-message info-message--success" }, { children: [_jsx(FontAwesomeIcon, { className: "info-message__icon", icon: faCheckCircle }, void 0), _jsx("h3", Object.assign({ className: "info-message__title" }, { children: t('QUESTION.AUDIO.UPLOADED') }), void 0), _jsx("p", { children: t('QUESTION.AUDIO.UPLOADED_DESCRIPTION') }, void 0)] }), void 0) }, void 0))] }, void 0));
};
export default RecorderControls;
